export default __webpack_public_path__ + "static/media/pixSplit.76cd6144.png";